// emorpi renk yuvarlakları (snippets/emorpi-swatches.liquid): üzerine gelince ya da dokununca kart görseli o renge geçer.
(() => {
  if (window.emorpiSwatches) return;
  window.emorpiSwatches = true;
  const touch = matchMedia('(hover: none)').matches;

  const select = (item) => {
    const card = item.closest('.card-wrapper');
    const img = card && card.querySelector('.card__media .media > img');
    if (!img || !item.dataset.src) return false;
    // Işıklar kapalıyken parlama ilk görsele hizalı: görsel değişmesin
    if (document.documentElement.classList.contains('e-lights-off') || card.closest('.e-dark')) return false;
    item.closest('.e-sw').querySelectorAll('.e-sw__item').forEach((el) => el.classList.toggle('is-active', el === item));
    if (img.dataset.src !== item.dataset.src) {
      // Ertelenmiş görselse yükleyici sonradan eski görseli koymasın
      delete img.dataset.eSrcset;
      delete img.dataset.eSrc;
      img.srcset = item.dataset.srcset || '';
      img.src = item.dataset.src;
      img.dataset.src = item.dataset.src;
    }
    // Kartın üzerinde dururken Dawn ikinci görsele geçer; renk seçiliyken seçilen renk görünsün
    card.classList.add('e-sw-chosen');
    return true;
  };

  document.addEventListener('pointerover', (e) => {
    if (e.pointerType !== 'mouse') return;
    const item = e.target.closest('.e-sw__item');
    if (item) select(item);
  });

  // Dokunmatik: ilk dokunuş rengi gösterir, seçili renge ikinci dokunuş ürün sayfasını açar
  document.addEventListener('click', (e) => {
    const item = e.target.closest('.e-sw__item');
    if (!item || !touch || item.classList.contains('is-active')) return;
    if (select(item)) e.preventDefault();
  });
})();
